import { render, staticRenderFns } from "./Creator-Category.vue?vue&type=template&id=fd7d013e&"
import script from "./Creator-Category.vue?vue&type=script&lang=ts&"
export * from "./Creator-Category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports